import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import IconPlus from 'components/icons/IconPlus';


import InventoryStockLineHistoryViewTableRow from './InventoryStockLineHistoryViewTableRow';

const styles = theme => ({
  root: {
    minHeight: 300,
    // overflow: 'hidden',
  },
  tableHead: {
    backgroundColor: theme.palette.grey[100],
  },
  tableRow: {
    height: 35,
  },
  tableCell: {
    paddingTop: 5,
    paddingBottom: 5,
    borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  tableCellHidden: {
    padding: 0,
    fontSize: 0,
  },
  button: {
    margin: -16,
    verticalAlign: 'middle',
  },
  iconPlus: {
    width: 16,
    height: 16,
    color: theme.palette.secondary[450],
  },
  iconMinus: {
    width: 16,
    height: 3,
    backgroundColor: theme.palette.secondary[450],
  },
});

const InventoryStockLineHistoryViewTable = ({
  inventoryStockLineHistory,
  onStockLineEdit,
  business,
  classes,
  ...otherProps
}) => {
  const withCases = inventoryStockLineHistory.find(item => item['Quantity In Case']);
  return (
    <div className={classes.root}>
      <Table className={classes.table}>
        <TableHead className={classes.tableHead}>
          <TableRow className={classes.tableRow}>
            <TableCell className={classes.tableCell}>Date</TableCell>
            <TableCell className={classes.tableCell}>Activity</TableCell>
            <TableCell className={classes.tableCell}>Patient</TableCell>
            <TableCell className={classes.tableCell}>Order Number</TableCell>   
            {otherProps['Calories Per Unit'] && (
              <Fragment>
                <TableCell className={classes.tableCell}>Cases</TableCell>
                <TableCell className={classes.tableCell}>Units per Case</TableCell>
                <TableCell className={classes.tableCell}>Units</TableCell>
                <TableCell className={classes.tableCell}>Unit Cost</TableCell>
                <TableCell className={classes.tableCell}>Cal Units</TableCell>
                <TableCell className={classes.tableCell}>Cal Unit Cost</TableCell>
              </Fragment>
            )}
            {(!otherProps['Calories Per Unit'] && withCases) && (
              <Fragment>
                <TableCell className={classes.tableCell}>Cases</TableCell>
                <TableCell className={classes.tableCell}>Units per Case</TableCell>
                <TableCell className={classes.tableCell}>Units</TableCell>
                <TableCell className={classes.tableCell}>Unit Cost</TableCell>
              </Fragment>
            )}
            {(!otherProps['Calories Per Unit'] && !withCases) && (
              <Fragment>
                <TableCell className={classes.tableCell}>Units</TableCell>
                <TableCell className={classes.tableCell}>Unit Cost</TableCell>
              </Fragment>
            )}
            <TableCell className={classes.tableCell}>Retail Price</TableCell>
            <TableCell className={classes.tableCell}>Delivery</TableCell>
            <TableCell className={classes.tableCell}>Facility</TableCell>
            <TableCell className={classes.tableCell}>Warehouse</TableCell>
            <TableCell className={classes.tableCell}>Expiration Date</TableCell>
            <TableCell className={classNames(classes.tableCell, classes.tableCellHidden)}>
              Edit
            </TableCell>
            <TableCell className={classNames(classes.tableCell, classes.tableCellHidden)}>
              Delete
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {inventoryStockLineHistory
            .map((item, index, items) => (
              <InventoryStockLineHistoryViewTableRow
                key={item.ID}
                onEdit={onStockLineEdit}
                {...item}
                {...{ 'Product ID': otherProps['Product ID'] }}
                {...{ 'Calories Per Unit': otherProps['Calories Per Unit'] }}
                {...(withCases && !item['Quantity In Case']) ? {
                  'Quantity In Case': withCases['Quantity In Case'],
                } : {}}
                business={business}
              />
            ))}
        </TableBody>
      </Table>
    </div>
  );
};

InventoryStockLineHistoryViewTable.propTypes = {
  inventoryStockLineHistory: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  onStockLineEdit: PropTypes.func,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    tableHead: PropTypes.string.isRequired,
    tableRow: PropTypes.string.isRequired,
    tableCell: PropTypes.string.isRequired,
    tableCellHidden: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryStockLineHistoryViewTable.defaultProps = {
  onStockLineEdit: () => {},
  business: {},
};

export default withStyles(styles)(InventoryStockLineHistoryViewTable);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryStockLineHistoryViewDialog/InventoryStockLineHistoryViewTable.js